import { StyleSheet } from 'react-native';
import { darkTheme } from '../../../src/theme/themes';
import { CUSTOMIZER_SURFACE } from './characterCustomizer.constants';

export const coinPillStyles = StyleSheet.create({
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingLeft: 8,
    paddingRight: 16,
    paddingVertical: 6,
    borderRadius: 9999,
    backgroundColor: CUSTOMIZER_SURFACE.coinPillBg,
    borderWidth: 2,
    borderColor: darkTheme.primary,
    shadowColor: darkTheme.primary,
    shadowOpacity: 0.45,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 0 },
    elevation: 4,
  },
  coin: {
    width: 24,
    height: 24,
  },
  amount: {
    color: darkTheme.accent,
    fontWeight: '800',
    fontSize: 17,
    fontVariant: ['tabular-nums'],
  },
});
